import { makeAutoObservable } from "mobx"
import { UIStore } from "./UIStore";
import * as Models from '../models/';
import { DbEntity } from '../models/DbEntity';

import axios from 'axios';
import
{
	AxiosResponse
	, AxiosError
} from 'axios';
import { ModalTypeEnum } from "./libraries/ModalLibrary";
import { CategoryComponentLibrary } from "./libraries/CategoryComponentLibrary";
import * as DateFNS from "date-fns";

export class DataStore
{

	public uiState: UIStore;

	constructor()
	{
		makeAutoObservable(this, {});
		this.uiState = new UIStore(this);
	}

	public Categories: Map<string, Models.StatementCategoryModel> = new Map<string, Models.StatementCategoryModel>();
	setCategories(value: Map<string, Models.StatementCategoryModel>)
	{
		this.Categories = value;
	}

	public Statuses: Map<string, Models.StatementStatusModel> = new Map<string, Models.StatementStatusModel>();
	setStatuses(value: Map<string, Models.StatementStatusModel>)
	{
		this.Statuses = value;
		this.clearStatusCodes();
		let sc: Map<Models.StatementStatusEnum, Models.StatementStatusModel> = new Map<Models.StatementStatusEnum, Models.StatementStatusModel>();
		value.forEach((val) => sc.set(val.Code as Models.StatementStatusEnum, val));
		this.setStatusCodes(sc);
	}

	/** ключ - StatusCodeEnum, значение - Дата перехода в этот статус  **/
	public StatusHistory: Map<Models.StatementStatusEnum, string> = new Map<Models.StatementStatusEnum, string>();
	setStatusHistory(value: Map<Models.StatementStatusEnum, string>)
	{
		this.StatusHistory = value;
	}

	public StatusCodes: Map<Models.StatementStatusEnum, Models.StatementStatusModel> = new Map<Models.StatementStatusEnum, Models.StatementStatusModel>();
	setStatusCodes(value: Map<Models.StatementStatusEnum, Models.StatementStatusModel>)
	{
		this.StatusCodes = value;
	}
	clearStatusCodes()
	{
		this.StatusCodes.clear();
	}

	public FileTypes: Map<string, Models.StatementFileTypeModel> = new Map<string, Models.StatementFileTypeModel>();
	setFileTypes(value: Map<string, Models.StatementFileTypeModel>)
	{
		this.FileTypes = value;
	}

	public BackendVersion: string = "";
	setBackendVersion(value: string) { this.BackendVersion = value;}

	public OriginalCategoryFileTypes: Models.CategoryFileTypeModel[] = [];
	setOriginalCategoryFileTypes(value: Models.CategoryFileTypeModel[])
	{
		this.OriginalCategoryFileTypes = value;
	}

	/** ключ - CategoryId, значение - список типов файлов  **/
	public CategoryFileTypes: Map<string, Models.StatementFileTypeModel[]> = new Map<string, Models.StatementFileTypeModel[]>();
	setCategoryFileTypes()
	{
		this.CategoryFileTypes = this.MapFromCategoryFileTypes(this.OriginalCategoryFileTypes);
	}

	public Statement: Models.StatementModel | null = null;
	setStatement(value: Models.StatementModel)
	{
		this.Statement = value;
	}

	public ApiRoot: string = process.env.NODE_ENV === 'development' ? "/api/front/" : process.env.PUBLIC_URL+"/api/front/";

	private MapFromArray<Type extends DbEntity>(arr: Type[]): Map<string, Type>
	{
		let m: Map<string, Type> = new Map<string, Type>();
		arr.forEach((val) => m.set(val.Id, val));
		return m;
	}

	public MapFromCategoryFileTypes(arr: Models.CategoryFileTypeModel[]): Map<string, Models.StatementFileTypeModel[]>
	{
		let m: Map<string, Models.StatementFileTypeModel[]> = new Map<string, Models.StatementFileTypeModel[]>();
		arr.forEach((val) =>
		{
			if (this.Statement)
			{
				let allow: boolean = false;
				switch (this.Statement.StatementType)
				{
					case Models.StatementTypeEnum.NewInformation: allow = val.NewInformation; break;
					case Models.StatementTypeEnum.ClarifyInformation: allow = val.ClarifyInformation; break;
					case Models.StatementTypeEnum.RemoveInformation: allow = val.RemoveInformation; break;
				}
				if (!allow) return;
			}

			let ft = this.FileTypes.get(val.FileTypeId);
			if (ft)
			{
				let itemArray = m.get(val.CategoryId);
				if (!itemArray)
				{
					itemArray = [ft];
					m.set(val.CategoryId, itemArray);
				}
				else
				{
					itemArray.push(ft);
				}
			}
		});
		return m;
	}

	public UpdateSatementFromServer(validateOnlyStatus:boolean)
	{
		if (this.Statement)
		{
			// Register
			this.uiState.register.setComment(this.Statement.Comments ?? "");
			this.uiState.register.setStatementType((this.Statement.StatementType ?? "NewInformation") as Models.StatementTypeEnum);
			this.uiState.register.OldRegisterNumber.setValue(this.Statement.StatementPrevNumber ?? undefined);
			this.uiState.register.FeedbackEmail.setConfirmedValue(this.Statement.FeedbackEmail);
			this.uiState.register.FeedbackEmail.setValue(this.Statement.FeedbackEmail);
			if (this.Statement.StatementPrevDate)
			{
				let dt = DateFNS.parseISO(this.Statement.StatementPrevDate);
				if (DateFNS.isValid(dt)) this.uiState.register.OldRegisterDate.setValue(dt);
				else this.uiState.register.OldRegisterDate.setValue(null);
			}
			else
			{
				this.uiState.register.OldRegisterDate.setValue(null);
			}
			this.uiState.register.clearSelectedServiceCategories();
			this.Statement.StatementInfos.forEach((val) =>
			{
				let sc: Models.StatementCategoryModel | undefined = this.Categories.get(val.CategoryId);
				if (sc) this.uiState.register.setSelectedServiceCategories(sc, val.Operation);
			});
			this.uiState.register.Validate(validateOnlyStatus);

			// Info
			this.uiState.info.OrganizationName.setValue(this.Statement.OrganizationName);
			this.uiState.info.OrganizationInn.setValue(this.Statement.OrganizationInn);
			this.uiState.info.OrganizationKpp.setValue(this.Statement.OrganizationKpp);
			this.uiState.info.OrganizationHeadFirstName.setValue(this.Statement.OrganizationHeadFirstName);
			this.uiState.info.OrganizationHeadLastName.setValue(this.Statement.OrganizationHeadLastName);
			this.uiState.info.OrganizationHeadSecondName.setValue(this.Statement.OrganizationHeadSecondName);
			this.uiState.info.OrganizationHeadSecondNameExists.setValue(this.Statement.OrganizationHeadSecondNameExists);
			this.uiState.info.OrganizationHeadPosition.setValue(this.Statement.OrganizationHeadPosition);
			this.uiState.info.AgreementCheck.Value = this.Statement.AgreementCheck;
			this.Statement.StatementInfos.forEach((val) =>
			{
				let sc: Models.StatementCategoryModel | undefined = this.Categories.get(val.CategoryId);
				if (sc)
				{
					let ccl: CategoryComponentLibrary | undefined = this.uiState.register.SelectedServiceCategories.get(sc.Id);
					if (ccl)
					{
						ccl.Email.setValue(val.Email);
						ccl.Phone.setValue(val.Phone);
						ccl.Web.setValue(val.Href);
						ccl.setOperation(val.Operation);
					}
				}
			});
			this.uiState.info.Validate(validateOnlyStatus);

			// Files
			this.uiState.files.setCurrentStorageSize(0);
			this.uiState.files.clearFileList();
			this.uiState.files.setSortedFileTypeArray([]);
			this.uiState.files.UpdateFileTypes();
			this.Statement.StatementFileInfos.forEach((val) =>
			{
				this.uiState.files.AddFileLibraryFromServer(val.FileTypeId, val.FileName, val.FileSize, true, Models.FileStateEnum.Succeed, val.Id, val.PageCount);
			});
			this.uiState.files.Validate(validateOnlyStatus);

			// statuses
			this.UpdateStatementStatusHistory();
		}
	}

	private UpdateStatementStatusHistory(): boolean
	{
		let retVal: boolean = true;
		if (this.Statement)
		{
			let statusCode = this.Statuses.get(this.Statement.StatusId)?.Code;
			if (statusCode) this.uiState.setStatementStatus(statusCode as Models.StatementStatusEnum);

			let historyMap = new Map<Models.StatementStatusEnum, string>();
			this.Statement.StatementStatusHistory.forEach((val) =>
			{
				let statusCode = this.Statuses.get(val.StatusId)?.Code;
				if (statusCode)
				{
					let s: Models.StatementStatusEnum = statusCode as Models.StatementStatusEnum;
					historyMap.set(s, val.CreateDate)
					if (s === Models.StatementStatusEnum.Received) retVal = false;
				}
			});
			this.setStatusHistory(historyMap);
		}
		return retVal;
	}

	public CreateSatementFromClient(): Models.StatementModel
	{
		if (!this.Statement) throw new Error("Нельзя загружать файл при несозданном заявлении");

		let statement = new Models.StatementModel();

		statement.Id = this.Statement.Id;
		statement.StatusId = this.Statement.StatusId;
		statement.CreateDate = DateFNS.formatISO(new Date());
		statement.FormTrigger = false;


		// register
		statement.Comments = this.uiState.register.Comment;
		statement.StatementType = this.uiState.register.StatementType;

		statement.StatementPrevNumber = this.uiState.register.OldRegisterNumber.Value;

		if (this.uiState.register.OldRegisterDate.Value!==null && this.uiState.register.OldRegisterDate.IsValid)
		{
			statement.StatementPrevDate = this.uiState.register.OldRegisterDate.toISO();
		}
		else
		{
			statement.StatementPrevDate = undefined;

		}
		statement.FeedbackEmail = this.uiState.register.FeedbackEmail.Value ?? "";
		statement.StatementInfos = [];

		this.uiState.register.SelectedServiceCategories.forEach((val) =>
		{
			let si: Models.StatementInfoModel = new Models.StatementInfoModel();
			si.CategoryId = val.Category.Id;
			si.Email = val.Email.Value ?? "";
			si.Href = val.Web.Value ?? "";
			si.Phone = val.Phone.Value ?? "";
			si.Operation = val.Operation;
			statement.StatementInfos!.push(si);
		});

		// info
		statement.OrganizationName = this.uiState.info.OrganizationName.Value ?? "";
		statement.OrganizationInn = this.uiState.info.OrganizationInn.Value ?? "";
		statement.OrganizationKpp = this.uiState.info.OrganizationKpp.Value ?? "";
		statement.OrganizationHeadFirstName = this.uiState.info.OrganizationHeadFirstName.Value ?? "";
		statement.OrganizationHeadLastName = this.uiState.info.OrganizationHeadLastName.Value ?? "";
		statement.OrganizationHeadSecondName = this.uiState.info.OrganizationHeadSecondName.Value ?? "";
		statement.OrganizationHeadSecondNameExists = this.uiState.info.OrganizationHeadSecondNameExists.Value ?? true;
		statement.OrganizationHeadPosition = this.uiState.info.OrganizationHeadPosition.Value ?? "";
		statement.AgreementCheck = this.uiState.info.AgreementCheck.Value === undefined ? false : this.uiState.info.AgreementCheck.Value;

		//files
		statement.StatementFileInfos = [];
		this.uiState.files.FileLists.forEach((arr) =>
		{
			arr.forEach((val) =>
			{
				let sfi: Models.StatementFileInfoModel = new Models.StatementFileInfoModel();
				sfi.Id = val.FileId;
				sfi.FileName = val.FileName;
				sfi.FileSize = val.FileSize;
				sfi.FileTypeId = val.FileTypeId;
				sfi.PageCount = val.PageCount;
				statement.StatementFileInfos!.push(sfi);
			});
		});

		return statement;
	}

	public LoadData(captchaToken?: string)
	{
		axios.post<Models.InitialDataResponse>(this.ApiRoot + "start/" + window.location.search, { token:captchaToken??""})
			.then((res: AxiosResponse<Models.InitialDataResponse>) =>
			{
				// убираем модалку
				this.uiState.modal.setShowModal(false);

				// запоминаем заявление
				if (res.data.Statement) this.setStatement(res.data.Statement);
				// запоминаем справочники
				this.setCategories(this.MapFromArray(res.data.Categories));
				this.setStatuses(this.MapFromArray(res.data.Statuses));
				this.setFileTypes(this.MapFromArray(res.data.FileTypes));
				this.setOriginalCategoryFileTypes(res.data.CategoryFileTypes);
				this.setCategoryFileTypes();// здесь используется загруженный this.Statement
				this.setBackendVersion(res.data.BackendVersion);
				// captcha 
				this.uiState.captcha.setPublicKey(res.data.Config.CaptchaPublicKey);
				this.uiState.captcha.setEnabled(res.data.Config.CaptchaEnabled);

				// если заявление передано от сервера
				if (this.Statement)
				{
					// парсим заявление (раскладываем по интерфейсу)
					this.UpdateSatementFromServer(true);

					// при наличии согласия на обработку перс данных, разрешаем переключаться по всем закладкам
					if (this.Statement.AgreementCheck) this.uiState.setDisabledTabs([]);
					// иначе разрешаем нажимать только в первые две закладки
					else this.uiState.setDisabledTabs([3, 4]);

					// если статус - отправлено, включаем следилку за статусом
					if (this.uiState.StatementStatus === Models.StatementStatusEnum.Sent) this.StartStatusHistoryUpdater();

					// если форма уже есть, показываем четвертую страницу для работы с формой
					if (this.uiState.StatementStatus !== Models.StatementStatusEnum.NotCreated)
					{
						this.uiState.setActiveTab(4);
					}

				}
				// если сервер не передал заявление, значит почта еще не подтверждена
				else
				{
					// запрещаем нажимать в закладки
					this.uiState.setDisabledTabs([2, 3, 4]);
				}

				this.uiState.setFillButtons(res.data.FillButtons);

				this.uiState.setIsLoading(false);
			})
			.catch((res: AxiosError) =>
			{
				this.uiState.modal.setShowModal(false);
				if (res.response?.data)
				{
					let error = (res.response.data as Models.ErrorResponse);
					if (error && error.MessageToUser && error.ActivityId)
					{
						this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Сбой загрузки данных", error.MessageToUser + " (" + error.ActivityId + ")");
					}
					else
					{
						this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Сбой загрузки данных", "Сервер недоступен");
					}
					return;
				}
				else this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Сбой загрузки данных", "Загрузка данных завершилась ошибкой. Обновите страницу через некоторое время.");
			});
	}

	public SaveData()
	{
		if (!this.Statement) return Promise.reject("Нельзя загружать файл при несозданном заявлении");

		return axios.put<Models.SaveDataResponse>(
			this.ApiRoot
			+ "statement/" + this.Statement.Id,
			this.CreateSatementFromClient()
		);
	}

	public ProcessFormDeleted(data: Models.FormDeletedResponse): void
	{
		if (!data.FormDeleted || this.Statement === null) return;

		this.Statement.StatementStatusHistory = data.Statuses.StatementStatusHistory;
		this.Statement.StatusId = data.Statuses.StatusId;
		this.Statement.LinkClarify = data.Statuses.LinkClarify;
		this.Statement.LinkReadonly = data.Statuses.LinkReadonly;
		this.UpdateStatementStatusHistory();
	}

	// #region StatusHistoryUpdater

	public StartStatusHistoryUpdater()
	{
		setTimeout(() =>
		{
			if (!this.Statement) return;

			axios
				.get<Models.StatementStatusesModel>
				(
					this.ApiRoot
					+ "statement/" + this.Statement.Id
					+ "/status"
				)
				.then((res) =>
				{
					if (!res.data) return;

					if (this.Statement === null) this.Statement = new Models.StatementModel();
					this.Statement.StatementStatusHistory = res.data.StatementStatusHistory;
					this.Statement.StatusId = res.data.StatusId;
					this.Statement.LinkClarify = res.data.LinkClarify;
					this.Statement.LinkReadonly = res.data.LinkReadonly;
					if (this.UpdateStatementStatusHistory())
					{
						this.StartStatusHistoryUpdater();
						return;
					}
				})
				.catch(() =>
				{
					return;
				});
		}, 5000);
	}
	// #endregion

	// #region FORM
	public CreateForm()
	{
		if (!this.Statement) return Promise.reject("Нельзя формировать форму при несозданном заявлении");

		return axios.post<Models.StatementModel>
			(
				this.ApiRoot
				+ "statement/" + this.Statement.Id
				+ "/form"
			);
	}

	public SendForm()
	{
		if (!this.Statement) return Promise.reject("Нельзя посылать форму при несозданном заявлении");

		return axios.put<Models.StatementModel>
			(
				this.ApiRoot
				+ "statement/" + this.Statement.Id
				+ "/form"
			);
	}

	public GetFormLink()
	{
		if (!this.Statement) throw new Error("Нельзя скачивать форму при несозданном заявлении");

		return this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/form";
	}

	public DeleteForm()
	{
		if (!this.Statement) return Promise.reject("Нельзя удалять файл при несозданном заявлении");

		return axios.delete<Models.StatementModel>
			(
				this.ApiRoot
				+ "statement/" + this.Statement.Id
				+ "/form"
			);
	};
	// #endregion

	public GetSgnFileLink()
	{
		if (!this.Statement) throw new Error("Нельзя скачивать подпись при несозданном заявлении");

		return this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/sign";
	}

	public SendCheckMail(request: Models.SendMailCheckRequest)
	{
		this.uiState.modal.setShowModal(true, ModalTypeEnum.Spinner, "Отправка письма");
		axios.post(this.ApiRoot + "send_check_mail", request)
			.then((res: AxiosResponse) =>
			{
				this.uiState.modal.setShowModal(false);
				this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Подтверждение  адреса электронной почты", "Сообщение с ссылкой для продолжения регистрации отправлено. Проверьте Вашу электронную почту.");
			})
			.catch((res: AxiosError) =>
			{
				this.uiState.modal.setShowModal(false);

				if (res.response?.data)
				{
					let error = (res.response.data as Models.ErrorResponse);
					if (error && error.MessageToUser && error.ActivityId)
					{
						this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Подтверждение  адреса электронной почты", error.MessageToUser + " (" + error.ActivityId + ")");
					}
					else
					{
						this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Подтверждение  адреса электронной почты", "Сервер недоступен");
					}
					return;
				}
				else this.uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Подтверждение  адреса электронной почты", "Отправка письма не удалась");
			});
	}

	public UploadFileChunk(fileTypeId: string, fileId: string, chunkNum: number, chunkData: any)
	{
		if (!this.Statement) return Promise.reject("Нельзя загружать файл при несозданном заявлении");

		var formData = new FormData();
		formData.append('chunkData', chunkData);

		return axios.post<Models.FormDeletedResponse>(
			this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/file_type/" + fileTypeId
			+ "/file/" + fileId
			+ "/chunk/" + chunkNum,
			formData
		);
	};

	public UploadFileCompleted(fileTypeId: string, fileId: string, fileName: string)
	{
		if (!this.Statement) return Promise.reject("Нельзя загружать файл при несозданном заявлении");

		let requestData = new Models.UploadCompleteRequest();
		requestData.FileName = fileName;

		return axios.post<Models.FormDeletedResponse>(
			this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/file_type/" + fileTypeId
			+ "/file/" + fileId
			+ "/complete",
			requestData
		);
	};

	public DeleteFile(fileTypeId: string, fileId: string)
	{
		if (!this.Statement) return Promise.reject("Нельзя удалять файл при несозданном заявлении");

		return axios.delete<Models.FormDeletedResponse>(
			this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/file_type/" + fileTypeId
			+ "/file/" + fileId
		);
	};


	public DeleteSgnFile()
	{
		if (!this.Statement) return Promise.reject("Нельзя удалять файл при несозданном заявлении");

		return axios.delete(
			this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/sign"
		);
	};

	public UploadSgnFile(data: Blob)
	{
		if (!this.Statement) return Promise.reject("Нельзя удалять файл при несозданном заявлении");

		var formData = new FormData();
		formData.append('data', data);

		return axios.post(
			this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/sign",
			formData
		);
	};

	public UploadSgn(algorithm: string, signature: string, pluginVersion: string, cSPVersion: string, cSPName: string)
	{
		if (!this.Statement) return Promise.reject("Нельзя удалять файл при несозданном заявлении");

		return axios.post(
			this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/sign"
			+ "/base64",
			new Models.UploadSignBase64Request(algorithm, signature, pluginVersion, cSPVersion, cSPName)
		);
	};

	public GetFileLink(fileTypeId: string, fileId: string): string
	{
		if (!this.Statement) throw new Error("Нельзя удалять файл при несозданном заявлении");

		return this.ApiRoot
			+ "statement/" + this.Statement.Id
			+ "/file_type/" + fileTypeId
			+ "/file/" + fileId;
	};

}
